import React from "react";
import "./index.css";
import {
  DataGrid,
  GridColDef,
  GridActionsCellItem,
  GridRowId,
} from "@mui/x-data-grid";
import { CollectionSite } from "../../../types";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from "@mui/material";

interface Props {
  collectionSites?: CollectionSite[];
  handleOpen: () => void;
  handleEdit: (arg0: CollectionSite) => void;
  loading: boolean;
}

const CollectionSites: React.FC<Props> = ({
  collectionSites,
  handleOpen,
  handleEdit,
  loading,
}) => {
  const handleDeleteClick = (id: GridRowId) => () => {
    // setRows(rows.filter((row) => row.id !== id));
  };

  const handleEditClick = (id: GridRowId) => () => {
    handleEdit(collectionSites?.filter((row) => row.id === id)[0] || {});
  };


  const columns: GridColDef[] = [
    { field: "displayName", headerName: "Display Name", width: 150 },
    { field: "description", headerName: "Description", width: 150 },
    { field: "address", headerName: "Address", flex: 1 },
    { field: "gps", headerName: "GPS", width: 250 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const handleCreateClick = (): void => {
    handleOpen();
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="table-collection">
        <DataGrid
          loading={loading}
          rows={collectionSites}
          columns={columns}
          sx={{ "--DataGrid-overlayHeight": "100%" }}
        />
      </div>
      <div className="btn-create-new-trap-site-wrapper">
        <Button
          variant="contained"
          href="#contained-buttons"
          onClick={handleCreateClick}
        >
          Create New Trap Site
        </Button>
      </div>
    </div>
  );
};

export default CollectionSites;
